import React from 'react'
import { getFormattedValue } from '../utils/currency'

const currencyStyle = { whiteSpace: 'nowrap' }

const FormattedNumber = (props) => <span style={currencyStyle}>{getFormattedValue(props.value)}</span>

export default FormattedNumber
